import FeedbackButton from 'components/feedbackbutton/FeedbackButton';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getCardById, getDisplayNumberById, getPlaceDisplayName } from '../../../assets/cards/cards';
import { ReactComponent as Forward } from '../../../assets/icons/forward.svg';
import { ReactComponent as Up } from '../../../assets/icons/up.svg';
import BottomSheet from '../../../components/bottomsheet/BottomSheet';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import InfoIcon from '../../../components/infoicon/InfoIcon';
import H1 from '../../../components/text/H1';
import { tag } from '../../../services/ATInternetService';
import { updateCardScore } from '../../../stored/Collection';
import { QuizCard } from '../lockedcard/LockedCard';
import UnlockedCardMessage from '../lockedcard/UnlockedCardMessage';
import './UnlockedCard.sass';


const UnlockedCard = ({ card, isExpanded, onRequestHideAR, foundAt, score, cardId }) => {
	const [hasScrolled, setHasScrolled] = useState(false);
	const [doingQuiz, setDoingQuiz] = useState(false);
	const [doingQuizScore, setDoingQuizScore] = useState(0);
	const [hasUnlockedUpgradedCard, setHasUnlockedUpgradedCard] = useState(false);
	const [isSpecialCard, setIsSpecialCard] = useState(score === 6);

	useEffect(() => {

	}, [doingQuiz, doingQuizScore, isSpecialCard]);

	if (doingQuiz) {
		if (!hasUnlockedUpgradedCard) {
			return <QuizCard
				isUnlocked
				card={getCardById(card.cardId)}
				foundAt={foundAt}
				score={doingQuizScore}
				onUnlocked={() => {
					tag.sendClick('quiz', {
						chapter3: card.id,
						name: `retried-${score}`,
					});
					if (doingQuizScore > score) {
						updateCardScore(cardId, doingQuizScore);
						setIsSpecialCard(doingQuizScore === 6);
					}
					setHasUnlockedUpgradedCard(true);
				}}
				onRightAnswer={() => {
					const newScore = doingQuizScore + 1;
					setDoingQuizScore(newScore);
				}}
				onQuizQuestionVisibilityChanged={() => { }}
			/>;
		}
		return <UnlockedCardMessage
			card={getCardById(card.cardId)}
			foundAt={foundAt}
			score={doingQuizScore}
			goBack={() => setDoingQuiz(false)}
		/>
	}

	return <>
		<BottomSheet color={getCardById(card.cardId).colors.primary}>
			<div
				className="unlockedcard __cardcolors flex flex-col bg-black bg-opacity-20 h-full"
				onTouchMove={isExpanded ? null : () => onRequestHideAR(true)}>
				<div className={`px-2 pt-2 ${isSpecialCard ? 'unlockedcard__special--full' : ''}`}>
					<div className="flex flex-row px-4 pt-4">
						<H1 xl shadow>{getCardById(card.cardId).displayName}</H1>
						{isSpecialCard ? <div
							className="text-white inline font-bold text-lg rounded-full px-3 align-middle leading-9 shadow-md"
							style={{
								background: 'var(--primary-color)'
							}}>
							{getDisplayNumberById(getCardById(card.cardId).id)}
						</div> : <div className="inline bg-white text-black font-bold text-lg rounded-full px-3 align-middle leading-9 shadow-md">
							{getDisplayNumberById(getCardById(card.cardId).id)}
						</div>}
					</div>
					<p className="mb-4 italic font-light px-4">
						{getCardById(card.cardId).info.scientificName.value}
					</p>

					{/* eslint-disable-next-line react/no-danger */}
					<style dangerouslySetInnerHTML={{
						__html: `
						.__cardcolors {
							--primary-color: ${getCardById(card.cardId).colors.primary};
							--secondary-color: ${getCardById(card.cardId).colors.secondary};
						}
						.cardcolored path {
							fill: ${getCardById(card.cardId).colors.primary};
							transform-origin: center;
							transition: all 300ms ease-in-out;
							transform: rotate(${isExpanded ? '180deg' : '0deg'});
						}
				`}}
					/>

					<div className={isExpanded ? 'overflow-hidden transition-all' : ''} style={{ borderRadius: (hasScrolled && isExpanded) ? '0.5rem 0.5rem 0 0' : '2.5rem 2.5rem 0 0', }}>
						<div
							className={`flex-grow py-4 text-center relative transition-all delay-100 duration-700 ${isExpanded ? 'unlockedcard__info--expanded' : 'unlockedcard__info--collapsed'}`}
							style={{
								background: getCardById(card.cardId).colors.primary,
								borderRadius: hasScrolled ? '0.5rem 0.5rem 0 0' : '2.5rem 2.5rem 0 0',
								boxShadow: hasScrolled ? 'inset rgba(0, 0, 0, 0.1) 0px 5px 5px' : '',
							}}
							onScroll={(event) => {
								// @ts-ignore
								setHasScrolled(event.target.scrollTop > 5);
							}}>
							{
								!isExpanded && <>
									<PrimaryButton
										color={getCardById(card.cardId).colors.primary}
										onClick={() => onRequestHideAR(true)}
										onTouchMove={() => onRequestHideAR(true)}
										className="absolute transform -translate-x-1/2 -translate-y-full left-1/2 z-10 mt-2 -bottom-12"
										style={{
											borderRadius: '2rem 2rem 0 0',
											boxShadow: 'rgb(0 0 0 / 25%) 0px 0px 1rem',
										}}>
										<Up className="unlockedcard__swiper cardcolored" />
									</PrimaryButton>
								</>
							}

							{
								<InfoSection
									addBottomMargin
									photo={getCardById(card.cardId).info.scanner.photo}
									type="scanner"
									title={getPlaceDisplayName(foundAt)}
									description={getCardById(card.cardId).info.scanner.description.replace('{{location}}', getPlaceDisplayName(foundAt))}
									color={getCardById(card.cardId).colors.primary}
								/>
							}
							{
								!isSpecialCard && <SpecialCard
									color={getCardById(card.cardId).colors.primary}
									plural={getCardById(card.cardId).plural}
									onShowQuizRequested={() => {
										if (isExpanded) onRequestHideAR(false);
										setHasUnlockedUpgradedCard(false)
										setDoingQuizScore(0);
										setDoingQuiz(true);
									}}
									cardId={card.cardId}
								/>
							}
							{
								Object.keys(getCardById(card.cardId).info).map((key, index) => {
									if (!['scientificName', 'scanner'].includes(key) && getCardById(card.cardId).info[key].value) {
										return <InfoSection
											addBottomMargin={index !== Object.keys(getCardById(card.cardId).info).length - 1}
											photo={getCardById(card.cardId).info[key].photo}
											type={key}
											title={getCardById(card.cardId).info[key].value}
											description={getCardById(card.cardId).info[key].description}
											color={getCardById(card.cardId).colors.primary}
											key={key}
										/>
									} return <></>;
								})
							}
							{
								<FeedbackSection
									color={getCardById(card.cardId).colors.primary}
								/>
							}
							<div className={isExpanded ? 'h-4' : ''} />
						</div>
					</div>
				</div>
			</div>
		</BottomSheet>
	</>;
};

UnlockedCard.propTypes = {
	foundAt: PropTypes.string.isRequired,
	isExpanded: PropTypes.any.isRequired,
	onRequestHideAR: PropTypes.any.isRequired,
	card: PropTypes.any.isRequired,
	score: PropTypes.any.isRequired,
	cardId: PropTypes.string.isRequired
}

const InfoSection = ({ addBottomMargin, type, color, photo, title, description }) => {
	const innerborderRadius = '1.7rem 1.7rem 0 0';
	return <div key={type} className={`bg-white mx-4 shadow-md overflow-hidden${addBottomMargin ? ' mb-4' : ''}`} style={{ borderRadius: '1.7rem 1.7rem 0.5rem 0.5rem', }}>
		<div className={photo ? 'absolute' : ''} style={{ borderRadius: innerborderRadius, background: photo ? '' : color, zIndex: 1, }}>
			<div className={`flex flex-row relative bg-black pl-2 ${photo ? 'bg-opacity-0' : 'bg-opacity-20'}`} style={{ borderRadius: innerborderRadius, }}>
				<div className="overflow-visible" style={{ transform: 'scale3d(1.1, 1.1, 1.1)' }}>
					<InfoIcon type={type} />
				</div>
				<H1 shadow className="pl-2 py-4">{title}</H1>
			</div>
		</div>
		{photo && <img className="w-full" src={`${window.location.pathname}/pictures/details/${photo}`} alt="Foto bij het stukje tekst" style={{ borderRadius: innerborderRadius, minHeight: '5rem', }} />}
		<p className="text-gray-darkest p-4 font-droid">
			{description}
		</p>
	</div>;
};

InfoSection.propTypes = {
	addBottomMargin: PropTypes.bool.isRequired,
	color: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	photo: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired
}

const SpecialCard = ({ cardId, color, plural, onShowQuizRequested }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const getBorderRadius = () => isExpanded ? '1.7rem 1.7rem 0.5rem 0.5rem' : '1.7rem';

	return <div className="bg-white mx-4 shadow-md mb-4 relative transition-all" style={{ borderRadius: getBorderRadius(), }}>
		<div className="overflow-hidden">
			<div className="overflow-hidden transition-all" style={{ borderRadius: getBorderRadius(), background: color }}>
				<div className="unlockedcard__special">
					<button className="flex flex-row relative pl-2 w-full" onClick={() => setIsExpanded(!isExpanded)} type="button">
						<img className="h-16 w-16 object-contain p-2" src="/klokhuisscanner/logo192.png?v1" alt="Logo" /><H1 shadow className="py-4">{isExpanded ? 'speciale kaart!' : 'speciale kaart?'}</H1>
					</button>
					{isExpanded &&
						<p className="text-black px-4 pt-4 mt-0 mx-4 font-droid bg-white unlockedcard__special__text rounded-t-2xl">
							Weet je al alles over {plural}? Maak van deze kaart een speciale kaart door de quiz helemaal goed te maken!
							<br />
							<PrimaryButton
								color={color}
								inverted
								className="my-4"
								onClick={() => {
									onShowQuizRequested();
									tag.sendClick('unlocked-card', {
										chapter3: cardId,
										name: 'quiz-opened',
									});
								}}><Forward /></PrimaryButton>
						</p>}
				</div>
			</div>
		</div>
	</div>;
}
SpecialCard.propTypes = {
	color: PropTypes.string.isRequired,
	plural: PropTypes.string.isRequired,
	cardId: PropTypes.string.isRequired,
	onShowQuizRequested: PropTypes.func.isRequired
}

const FeedbackSection = ({ color }) => {
	return <div className="bg-white mx-4 shadow-md overflow-hidden mt-4" style={{ borderRadius: '1.7rem', }}>
		<div style={{ borderRadius: '1.7rem 1.7rem 0 0', background: color, zIndex: 1, }}>
			<div className="flex flex-row relative bg-black pl-2 bg-opacity-20" style={{ borderRadius: '1.7rem 1.7rem 0 0' }}>
				<FeedbackButton className="w-full" />
			</div>
		</div>
	</div>;
}
FeedbackSection.propTypes = {
	color: PropTypes.string.isRequired,
}


export default UnlockedCard;
